import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { FormattedMessage } from 'react-intl';
import { InputReadyModalContent } from './modal-content/input-ready';
import { AutoBatchResponse } from './modal-content/auto-batch-response';
import { AutoBatchingContext } from './context';
import { PRE_PROCESSING, PROCESSING, PROCESSED } from './constants/processing-state';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import AutoBatchFooter from './footer';
import messages from './messages';
import style from './style.module.less';

const AutoBatchModal = ({ onCloseModal }) => {
  const { totalRecords, processState } = useContext(AutoBatchingContext);
  const showPreProcessingMessage = processState === PRE_PROCESSING || processState === PROCESSING;
  const showProcessedMessage = processState === PROCESSED;
  return (
    <Modal size='medium'>
      <ModalHeader>
        {showPreProcessingMessage && (
          <FormattedMessage
            {...messages.autoBatchingHeader}
            values={{
              totalRecords,
              b: (chunks) => <span className={style['part-bold']}>{chunks}</span>,
            }}
          />
        )}
        {showProcessedMessage && (
          <FormattedMessage
            {...messages.autoBatchingHeaderSucceeded}
            values={{
              totalRecords,
              b: (chunks) => <span className={style['part-bold']}>{chunks}</span>,
            }}
          />
        )}
      </ModalHeader>
      <ModalBody className={style['auto-batch-modal-body']}>
        {processState === PRE_PROCESSING && <InputReadyModalContent />}
        {processState === PROCESSING && <LoadingIndicator className={style['loading-icon']} />}
        {processState === PROCESSED && <AutoBatchResponse />}
      </ModalBody>
      <AutoBatchFooter onCloseModal={onCloseModal} />
    </Modal>
  );
};

AutoBatchModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
};

export default AutoBatchModal;
